import React, { useState } from 'react';
import { Button } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ColumnReorderMenu from './ColumnReorderMenu';

const DataGridColumnReorderButton = () => {
	const [anchorEl, setAnchorEl] = useState(null);

	return (
		<>
			<Button
				variant='text'
				size='small'
				startIcon={<ViewColumnIcon />}
				onClick={(event) => setAnchorEl(event.currentTarget)}
			>
				Columns
			</Button>
			<ColumnReorderMenu
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
			/>
		</>
	);
};

export default DataGridColumnReorderButton;
